/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "styled-components";
import MatButton from "@material-ui/core/Button";

const CustomMatButton = React.forwardRef((props: any, ref: any) => {
  const { variant, className, color } = props;
  return (
    <MatButton
      {...props}
      ref={ref}
      variant={variant || "contained"}
      color={color || "primary"}
      className={className}
      disableRipple={variant === "text" ? true : false}
    />
  );
});

const Button = styled(CustomMatButton)`
  ${({ theme }) => {
    return `
      &.MuiButtonBase-root {
        border-radius: 25px;
        border: 2px solid ${theme.palette.primary.main};
        padding: ${theme.spacing(2)}px ${theme.spacing(4)}px;
        font-size: 16px;
        line-height: 20px;
        box-shadow: none;
        max-width: 440px;
        height: 40px;
  
        &:hover {
          border-color: ${theme.palette.primary.dark};
        }
        
        &.Mui-disabled {
          border-color: ${theme.palette.text.disabled};
          color: ${theme.palette.text.disabled};
        }
      }
      
      &.MuiButton-containedPrimary {
        &:hover {
          background: ${theme.palette.primary.dark};
          color: white;
        }
  
        &.Mui-disabled {
          background: ${theme.palette.text.disabled};
          color: ${theme.palette.background.paper};
        }
      }
    
      &.MuiButton-containedSecondary {
        background: white;
        border: 2px solid ${theme.palette.primary.main};
        box-sizing: border-box;
        color: ${theme.palette.primary.main};
  
        &:hover {
          border-color: ${theme.palette.primary.dark};
          color: ${theme.palette.primary.dark};
        }
      }
  
      &.MuiButton-sizeSmall {
        font-size: 14px;
        line-height: 16px;
        padding: ${theme.spacing(1.25)}px ${theme.spacing(2)}px;
      }
    
      &.MuiButton-text {
        font-size: 14px;
        padding: 0;
        font-weight: 700;
        min-width: unset;
        border: 0;
        color: ${theme.palette.primary.main};
        background: none;
      }
      `;
  }}
`;

export default Button;
